import Vue from 'vue';

/**
 * @param el {Object} - the element the directive is bound to
 * @param val {String} - Members column width
 * @param mass {Array} - array of width hidden elements
 * @param ie {Boolean} - is IE browser flag
 * @returns {Number} of hidden elements
 */
export const isHide = (el, val, mass, ie) => {
    let onRow = 0;
    let otherElements = [];
    let element = el.getElementsByTagName('span');
    for (let i in mass) {
        onRow += mass[i] + 14;
        if (ie && onRow > Number(val) + 16 - 50) {
            otherElements.push(mass[i]);
            element[i].classList.add('hidden');
        }
        if (!ie && onRow > Number(val) - 48) {
            otherElements.push(mass[i]);
            element[i].classList.add('hidden');
        }
    }
    return otherElements.length;
};

export const showButton = button => {
    let target = event.target.parentNode.querySelectorAll('.hidden');
    for (let i = 0; i < target.length; i++) {
        target[i].classList.add('opened');
        target[i].classList.remove('hidden');
    }
    button.classList.add('open');
    button.classList.remove('cl');
    button.innerHTML = '&laquo;';
};

export const hideButton = button => {
    let target = event.target.parentNode.querySelectorAll('.opened');
    for (let i = 0; i < target.length; i++) {
        target[i].classList.remove('opened');
        target[i].classList.add('hidden');
    }
    button.classList.remove('open');
    button.classList.add('cl');
    button.innerText = target.length;
};

export const showOrHide = button => {
    if (button.textContent > 0) {
        showButton(button);
    } else {
        hideButton(button);
    }
};

const directive = {
    // Added event listener for button
    bind(el, binding) {
        Vue.nextTick(() => {
            let button = document.getElementById(binding.value.buttonId);
            button.addEventListener('click', showOrHide.bind(this, button));
        });
    },

    /**
     * This method calls when init page and every time when we change members column width
     * @param el {Object} - the element the directive is bound to
     * @param binding {Object} - object with parameters: 'width' and 'buttonId'
     */
    update(el, binding) {
        Vue.nextTick(() => {
            let btn = document.getElementById(binding.value.buttonId);
            // Clear previous values for button
            btn.classList.add('hidden');
            btn.classList.add('cl');
            btn.classList.remove('open');

            let sum = 0;
            let memberWidth;
            let mass = [];
            let j = 0;
            let groupMembers = el.getElementsByTagName('span');
            for (let i in groupMembers) {
                if (typeof groupMembers[i] === 'object') {
                    groupMembers[i].classList.remove('hidden');
                    memberWidth = getComputedStyle(groupMembers[i]).width.split('.')[0];

                    // Condition for correct forming array of staff members width for IE
                    if (memberWidth.includes('px')) {
                        memberWidth = memberWidth.split('px')[0];
                    }
                    sum += Number(memberWidth) + 14;
                    mass.push(Number(memberWidth));
                    if (binding.value.width) {
                        binding.value.width = binding.value.width.split('px')[0];
                        let isIE =
                            !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

                        if (isIE && sum > Number(binding.value.width) + 16 - 50) {
                            j = isHide(el, binding.value.width, mass, isIE);
                        }
                        if (!isIE && sum > Number(binding.value.width) - 48) {
                            j = isHide(el, binding.value.width, mass, isIE);
                        }
                    }
                }
            }

            if (j > 0) {
                btn.classList.remove('hidden');
                btn.classList.add('cl');
                btn.textContent = j;
            }
        });
    },

    unbind(el, binding) {
        Vue.nextTick(() => {
            let button = document.getElementById(binding.value.buttonId);
            if (button) {
                button.removeEventListener('click', showOrHide.bind(this, button));
            }
        });
    },
};

export default directive;
